import { Model } from '@df/catalog/model';
import { Listing } from '@df/catalog-ui/listing/listing';
import { IListingSortEngine, IListingSortOption } from '@df/catalog-ui/listing/sort/listing-sort';
import get from 'lodash-es/get';

export interface IListingSortOptionAttribute extends IListingSortOption {
    attributes?: string[];
}

export class ListingSortAttributeEngine<T extends Model = Model> implements IListingSortEngine<T> {
    public sort(collection: T[], option: IListingSortOptionAttribute, listing: Listing<T>, cb: (models: T[]) => void): void {
        const attributes = option.attributes || ([option.code].filter(i => !!i) as string[]);
        const resolvers = attributes.map(code => (code.includes('.') ? data => get(data, code.split('.')) : data => data[code]));
        const getValues = data => resolvers.map(resolver => resolver(data));
        cb(
            option.code
                ? collection.sort((a: T, b: T) => {
                      // we sort by all sortOptions that are in selection
                      // so we compare attributes till we find first difference
                      // if all attributes are same or undefined

                      const aVals = a.data ? getValues(a.data) : [];
                      const bVals = b.data ? getValues(b.data) : [];
                      const max = aVals.length;
                      let i = 0;
                      let result: number;
                      do {
                          result = this.compare(aVals[i], bVals[i], option.desc);
                      } while (!result && i++ < max);
                      return result;
                  })
                : collection
        );
    }

    public compare(aVal, bVal, invert: boolean = false): number {
        const inverter = invert ? -1 : 1;
        // for string we don't want case size to matter
        if (typeof aVal === 'string') {
            aVal = aVal.toLowerCase();
        } else if (typeof aVal === 'undefined') {
            aVal = 0;
        }

        if (typeof bVal === 'string') {
            bVal = bVal.toLowerCase();
        } else if (typeof bVal === 'undefined') {
            bVal = 0;
        }

        if (aVal > bVal) {
            return 1 * inverter;
        }

        if (aVal < bVal) {
            return -1 * inverter;
        }
        return 0;
    }
}
